import { getMobileOtp , getEmailOtp } from "../../../utils/loggingApiService"
import {verifyOtpForNewUsers , verifyOtpForMobile, verifyOtpForEmail} from "./apiServices"

export const handleDidntReceiveOtpButton = async (userLoginData)  => {
    if (userLoginData.selectedInput === 'mobile' ) { 
        let mobileOtpResponse = await getMobileOtp(userLoginData.mobileNumber)
        return {
            status : mobileOtpResponse.status,
        }
    }

    if ( userLoginData.selectedInput === 'email' ) { 
        let emailOtpResponse = await getEmailOtp(userLoginData.email)
        return {
            status : emailOtpResponse.status,
        }
    }
} 

export const handleOtpVerification = async (userLoginData, otp) => {
    let response ;
    let data = {
        otp
    }
    if (userLoginData.newUser) {
        if (userLoginData.selectedInput === "mobile") {
            data.mobileNumber = userLoginData.mobileNumber
        }
        if (userLoginData.selectedInput === "email") {
            data.email = userLoginData.email
        }
        response = await verifyOtpForNewUsers(data)
        
        return {
            status : response.status ,
            
        }
    }
    if (userLoginData.selectedInput === 'mobile' ) { 
        data.mobileNumber = userLoginData.mobileNumber
        response = await verifyOtpForMobile(data)
        
 
        // return {
        //     status : response.status,
        //     data : response.data
        // }
    }

    if ( userLoginData.selectedInput === 'email' ) { 
        data.email = userLoginData.email
        response = await verifyOtpForEmail(data)
        
        // return {
        //     status : response.status,
        //     data : response.data
        // }
    }

    if (response.status) {
        return {
                 status : response.status,
                 data : response.data
            }
    } else {
        return {
            status : response.status,
            error : response.error.msg
        }
    }
}